import { forwardRef, type HTMLAttributes } from "react";
import { cn } from "../../lib/utils";

export interface DockedRailProps extends HTMLAttributes<HTMLElement> {
  /** `default` is a narrow assistant rail; `wide` a full working pane. */
  width?: "default" | "wide";
}

/**
 * A non-modal panel docked to the right edge (Fråga CAIRE / Hjälp). Unlike
 * `Sheet`, it never traps focus, never closes on an outside click and keeps
 * its content mounted while hidden, so the planner works on the page beside
 * it. Layer, visibility and print behaviour are classes from the caller.
 */
export const DockedRail = forwardRef<HTMLElement, DockedRailProps>(
  function DockedRail({ width = "default", className, ...rest }, ref) {
    return (
      <aside
        ref={ref}
        className={cn(
          "fixed inset-y-0 right-0 h-dvh max-h-dvh w-full max-w-full flex-col border-l border-border bg-background shadow-2xl outline-none",
          width === "wide" ? "sm:max-w-5xl" : "sm:max-w-lg",
          className,
        )}
        {...rest}
      />
    );
  },
);
